import React from "react";
import { useIntl } from "react-intl";
import { v4 as uuid } from "uuid";
import { BLOCK_TYPES } from "../../../cores/websitePage/constants/blockTypes";
import { WebsiteBlock, WebsiteBlockType } from "../../../cores/websitePage/interfaces/WebsiteBlock";
import { BlockThumbnail } from "./BlockThumbnail";
import "./BlockLibrary.scss";
import "./BlockThumbnail.scss";
import "./website-builder.scss";

interface Props {
  onAddBlock: (block: WebsiteBlock) => void;
}

const BLOCK_CATEGORIES: { key: string; labelKey: string; types: WebsiteBlockType[] }[] = [
  {
    key: "layout",
    labelKey: "app.websitePage.blocks.category.layout",
    types: ["navbar", "hero", "columns", "spacer"],
  },
  {
    key: "content",
    labelKey: "app.websitePage.blocks.category.content",
    types: ["header", "text", "image", "video", "gallery"],
  },
  {
    key: "conversion",
    labelKey: "app.websitePage.blocks.category.conversion",
    types: ["button", "cta", "testimonials", "faq", "contact-form"],
  },
  {
    key: "structure",
    labelKey: "app.websitePage.blocks.category.structure",
    types: ["footer"],
  },
];

export function BlockLibrary({ onAddBlock }: Props) {
  const intl = useIntl();

  const handleAdd = (defaultBlock: Partial<WebsiteBlock>) => {
    onAddBlock({
      ...defaultBlock,
      id: uuid(),
    } as WebsiteBlock);
  };

  return (
    <div className="wp-block-library">
      {BLOCK_CATEGORIES.map((category) => {
        const blocks = BLOCK_TYPES.filter((b) => category.types.includes(b.type));
        if (blocks.length === 0) return null;

        return (
          <div key={category.key} className="wp-block-library__section">
            <h6 className="wp-block-library__section-title">
              {intl.formatMessage({ id: category.labelKey })}
            </h6>
            <div className="wp-block-library__grid">
              {blocks.map((blockType) => (
                <button
                  key={blockType.type}
                  type="button"
                  className="wp-block-library__item"
                  onClick={() => handleAdd(blockType.defaultBlock)}
                  title={intl.formatMessage({ id: blockType.labelKey })}
                >
                  <BlockThumbnail type={blockType.type} />
                  <span className="wp-block-library__item-label">
                    {intl.formatMessage({ id: blockType.labelKey })}
                  </span>
                </button>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
